<template>
    <div>
        <v-card flat>
            <v-card-title>
                {{ $t('payment_collection_report') }}
                <v-spacer></v-spacer>
                <v-btn @click="openPaymentCollectionReportPrintDialog" icon>
                    <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-menu
                    offset-y>
                    <template v-slot:activator="{on}">
                        <v-btn
                            icon
                            v-on="on"
                            class="mx-1">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list width="250" dense>
                        <v-list-item
                            @click="openSearchBy"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-magnify</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('search_by') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                            @click="sendSmsDecision"
                            link>
                            <v-list-item-icon>
                                <v-icon>mdi-message-alert</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ $t('send_collection_sms') }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-text>
                <v-data-table
                    :loading="loading.data"
                    v-model="selected"
                    :headers="headers"
                    :items="data"
                    show-select
                    dense
                    disable-pagination
                    hide-default-footer>
                    <template v-slot:[`item.code`]="{item}">
                        <a href="#" @click="openCustomerDisplayDialog({id: item.id})">{{item.code}}</a>
                    </template>
                    <template v-slot:[`item.balance`]="{item}">
                        {{ formatPrice(item.balance) }}
                    </template>
                    <template v-slot:[`item.can_receive_sms`]="{item}">
                        <v-icon :color="item.can_receive_sms ? 'success' : 'error'">{{item.can_receive_sms ? 'mdi-check' : 'mdi-close'}}</v-icon>
                    </template>
                </v-data-table>
                <!-- <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>{{ $t('code') }}</th>
                            <th>{{ $t('customers') }}</th>
                            <th>{{ $t('phone') }}</th>
                            <th>{{ $t('adderss') }}</th>
                            <th>{{ $t('balance') }}</th>
                            <th>{{ $t('last_transaction') }}</th>
                            <th>{{ $t('sale_person') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(paymentCollection, index) in paymentCollection.data" :key="index">
                            <td>{{ paymentCollection.code }}</td>
                            <td>{{ paymentCollection.name }}</td>
                            <td>{{ paymentCollection.phone }}</td>
                            <td>{{ paymentCollection.address }}</td>
                            <td>{{ formatPrice(paymentCollection.balance) }}</td>
                            <td style="width: 130px">{{ paymentCollection.last_transaction_date }}</td>
                            <td style="width: 130px">{{ paymentCollection.sales_person }}</td>
                        </tr>
                        <tr>
                            <th colspan="3"></th>
                            <th>{{ $t('total') }}</th>
                            <th>{{ formatPrice(paymentCollection.total) }}</th>
                        </tr>
                    </tbody>
                </v-simple-table> -->
            </v-card-text>
        </v-card>
        <RetryDialog
            ref="retryDialog"/>
        <SearchBy
            @search="searchPaymentCollection"
            ref="searchBy"/>
        <PaymentCollectionReportPrintDialog
            ref="paymentCollectionReportPrintDialog"/>
        <AlertDialog
            ref="alertDialog"/>
        <DecisionDialog
            @submit="decisionDialogHandler"
            ref="decisionDialog"/>
        <CustomerDisplayDialog
            @close="createdDataFetch"
            ref="customerDisplayDialog"/>
    </div>
</template>
<script>
import RetryDialog from '@/components/common/RetryDialog';
import PaymentCollectionReportPrintDialog from '@/components/Sales/PaymentCollectionReportPrintDialog';
import formatPrice from '@/utils/formatPrice';
import SearchBy from '@/components/common/SearchBy';
import { mapActions, mapState } from 'vuex';
import { map, filter } from "lodash";
import service from '../../services/service';
import AlertDialog from '../../components/common/AlertDialog';
import DecisionDialog from '../../components/common/DecisionDialog';
import CustomerDisplayDialog from '../../components/Sales/CustomerDisplayDialog';
export default {
    name: "PaymentCollectionReport",
    components: {
        RetryDialog,
        SearchBy,
        PaymentCollectionReportPrintDialog,
        AlertDialog,
        DecisionDialog,
        CustomerDisplayDialog
    },
    data() {
        return {
            openParams: null,
            loading: {
                data: false
            },
            dpk: '',
            headers: [
                {text: this.$t("code"), value: "code"},
                {text: this.$t("customer"), value: "name"},
                {text: this.$t("phone"), value: "phone"},
                {text: this.$t("adderss"), value: "address"},
                {text: this.$t("balance"), value: "balance"},
                {text: this.$t("last_transaction"), value: "last_transaction_date"},
                {text: this.$t("sale_person"), value: "sales_person"},
                {text: this.$t("can_receive_sms"), value: "can_receive_sms"}
            ],
            data: [],
            selected: []
        }
    },
    computed: {
        ...mapState('sales/report', ["paymentCollection"]),
        ...mapState('authentication', ["authorizations"]),
        selectedIds() {
            return map(this.selected, "id");
        }
    },
    methods: {
        formatPrice,
        ...mapActions('sales/report', ["getPaymentCollection"]),
        ...mapActions("sales/dpk", ["fetchDpk"]),
        async getDpkData() {
            let dpk = await this.fetchDpk();
            this.dpk = dpk.key;
        },
       async createdDataFetch(params) {
            try {
                this.loading.data = true;
                let response = await this.getPaymentCollection(params);
                this.data = response.data;
                this.loading.data = false;
            } catch(error) {
                let message = error.response ? error.response.data.message : error;
                this.$refs.retryDialog.open({ target: 'createdDataFetch', message });
            }
        },
        searchPaymentCollection(params) {
            this.openParams = params;
            this.createdDataFetch(params);
        },
        openSearchBy() {
            this.$refs.searchBy.open();
        },
        openPaymentCollectionReportPrintDialog() {
            this.$refs.paymentCollectionReportPrintDialog.open(this.paymentCollection);
        },
        sendDueBalanceSms() {
            service("/sales/bulksms/collection", "post", {selectedCustomersIds: this.selectedIds, dpk: this.dpk})
                .then(() => {
                    this.$refs.alertDialog.open({type: "success", message: this.$t("bulk_sms_sent")})
                })
                .catch((error) => {
                    let message = error.response ? error.response.data.message : error;
                    this.$refs.alertDialog.open({type: 'error', message});
                })
        },
        sendSmsDecision() {
            // 1. Find all selected customers that can receive sms.
            let customersCanReceiveSms = filter(this.selected, function(customer) {
                return customer.can_receive_sms == true;
            });

            let countCanReceiveSms = customersCanReceiveSms.length;

            let customerCannotReceiveSms = filter(this.selected, function(customer) {
                return customer.can_receive_sms != true;
            });
            // customerCannotReceiveSms = map(customerCannotReceiveSms, "name");

            let countCannotReceiveSms = customerCannotReceiveSms.length;

            // 1.1. Ensure atleast one selected customer can receive sms.
            // Alert Non of the selected customers can receive sms notifications.
            if(countCanReceiveSms == 0) {
                this.$refs.alertDialog.open({type: "error", message: this.$t("selected_cannot_receive_sms")});
                return;
            }
            
            let content = this.$t("are_you_sure_send_bulk_sms");
            if(countCannotReceiveSms > 0) {
                content += "<br>";
                content += "<br>";
                content += this.$t("customers_cannot_receive_sms")
                content += "<ul>";

                customerCannotReceiveSms.forEach(customer => {
                    content += "<li>" + customer.name + "</li>";
                });

                content += "</ul>";
            } 

            this.getDpkData();
            // 1.2 Notify user that there are selected customers that can receive sms.
            this.$refs.decisionDialog.open({target: "sendDueBalanceSms", title: this.$t("confirm_title"),content})
        },
        decisionDialogHandler({target}) {
            switch(target) {
                case "sendDueBalanceSms": this.sendDueBalanceSms(); break;
                default: alert("Decision Handler Target Error");
            }
        },
        openCustomerDisplayDialog({id}) {
            this.$refs.customerDisplayDialog.open({id});
        }
    },
    created () {
        this.createdDataFetch();
    }
}
</script>

<style scoped>
a {
    text-decoration: none;
    color: black;
    font-weight: bold;
}
a:hover {
    text-shadow: 0.5px 1px grey;
}
</style>